import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ViewChild, NgZone, OnDestroy, HostListener } from '@angular/core';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray, CdkDropList } from '@angular/cdk/drag-drop';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { DragDropService } from '../../services/drag-drop.service';
import { FormStateService } from '../../services/form-state.service';
import { Subscription ,finalize } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ChangeDetector } from 'src/app/shared/states/change-detector-state';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { Gradient } from 'src/app/shared/gradient-picker/gradient-picker.types';

interface FormSection {
    section_id: number;
    section_label: string;
    section_form_fields: FormField[];
    expanded?: boolean;
}

interface FormField {
    id: number | string;
    name: string;
    label: string;
    order_no: number;
    placeholder: string | null;
    description: string;
    type?: string;
    element_type: 'field' | 'group';
    options?: FieldOption[];
    properties?: FieldProperties;
    form_fields?: FormField[];
    max_duplicates?: number;
    is_required?: boolean;
    parent_group?: string;
    group_label?: string;
    original_id?: number;
    section_id?: number;
    section_label?: string;
    [key: string]: any;
}

interface FieldOption {
    label: string;
    value: string;
}

interface FieldProperties {
    file_format?: string[];
    file_max_size?: string;
}

@Component({
    selector: 'app-form-creation',
    templateUrl: './form-creation.component.html',
    styleUrls: ['./form-creation.component.css'],
    providers: [DragDropService],
    standalone: false
})
export class FormCreationComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('formLayout') formLayout?: CdkDropList;
    @ViewChild('availableSections') availableSections?: CdkDropList;

    isLoading: boolean = false;
    logoModified = false;
    coverModified = false;
    logoBaseUrl   = '';
    coverBaseUrl  = '';
    selectedCategory: string = '';
    previousSelectedCategory: string = '';
    selectedTab: string = 'sections';
    formFields: FormSection[] = [];
    formLayoutSections: FormSection[] = [];
    draggedField: any = null;
    selectedField: FormField | null = null;
    selectedSection: FormSection | null = null;
    categories: any = [
        { label: 'Registration', value: 'registration' },
        { label: 'Feedback', value: 'feedback' },
        { label: 'Documentation', value: 'documentation' },
        { label: 'Offer', value: 'offer' }
    ];

    private originalFormFields: FormSection[] = [];
    fieldsData: FormSection[] = [];
    private originalFieldsData: FormSection[] = [];
    formSettings: {
        formName: string;
        bg_colour: Gradient | null;
        logoImage: string;
        coverImage: string;
        logoPreview: string;
        coverPreview: string;
        touched: boolean;
    } = {
        formName: '',
        bg_colour: null,
        logoImage: '',
        coverImage: '',
        logoPreview: '',
        coverPreview: '',
        touched: true,
    };

    showHeader: boolean = false;
    showFooter: boolean = false;
    headerContent: string = '';
    footerContent: string = '';
    uploadingLogo: boolean = false;
    uploadingCover: boolean = false;
    companyId: string = '';
    bucketUrl: string = '';
    showPreviewDialog: boolean = false;
    previewFormData: any = null;
    isEditMode = false
    editFormUuid = ""
    originalFormData: any = null;
    cloneMode = false;
    savingForm: boolean = false;


    private dropListIds = new Set<string>();
    private stateSubscription: Subscription;

    searchForm!: FormGroup;
    showFormDetailsEdit: boolean = false;
    showFieldProperties: boolean = false;

    primeNgDummyModel = null;

    loadingCustomFields: boolean = false;
    fetchedCustomFields: boolean = false;
    formCustomFields: FormSection[] = [];
    formCustomFieldsCount: number = 0;
    formCustomFieldsMaxCount: number = 50;
    editingCustomField: FormField | null = null;
    showCustomFieldCreateDialog: boolean = false;
    customFieldTypeOptions = ["Input", "Email", "Dropdown", "File", "Radio", "Textarea", "Multi-file", "Multi-dropdown", "Checkbox", "Number", "Percentage", "Date Picker", "Mobile", "Paragraph"].map((val) => {return {label: val === "Mobile" ? "Mobile Number" : val, value: val}})

    readonly DISPLAY_FIELD_TYPES = ["paragraph"];

    readonly PLACEHOLDER_FIELD_TYPES = [
        "input", "email", "number", "percentage", "mobile", "date picker",
    ];
    readonly INPUT_FIELD_DESCRIPTION_MAX_LENGTH = 300;
    readonly DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH = 20000;
    readonly DISPLAY_FIELD_CONTENT_PLACEHOLDER =
        'Paste the full text to display. Use the buttons below to drop in a candidate\'s details.';

    paragraphCursor: { id: string, start: number, end: number } | null = null;

    private paragraphTokenCache: { signature: string, tokens: { label: string, token: string }[] } | null = null;

    showPlaceholderPicker: boolean = false;
    placeholderTarget: 'custom-field' | 'selected-field' | null = null;
    customFieldFileFormatOptions = [
        { label: 'PDF', value: 'pdf' },
        { label: 'Word', value: 'word' },
        { label: 'JPG', value: 'jpg' },
        { label: 'JPEG', value: 'jpeg' },
        { label: 'PNG', value: 'png' },
        { label: "PPTX",value:"pptx"}
    ];
    customFieldForm!: FormGroup;
    savingCustomField: boolean = false;

    showInfoSection: boolean = false;
    infoFeatures: { label: string, content: string }[] = [
        {
            label: "Drag & Drop Editor",
            content:
                "Use drag and drop to add new sections or fields to the form. You can also rearrange sections and reposition fields within or across sections."
        },
        {
            label: "Field Customization",
            content:
                "Select any field to open its property panel. You can update the label, placeholder, description, required status, and configure options based on the field type."
        },
        {
            label: "Dependent Fields",
            content:
                "Configure field dependencies by choosing which field should trigger visibility. The dependent field will appear only when the selected condition is met."
        },
        {
            label: "Custom Fields",
            content:
                "Create your own custom fields when predefined ones don't fit your needs. Once created, these fields can be reused across any form."
        },
    ];

    constructor(
        private formBuilderService: FormBuilderService,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private fileUploadService: FileUploadService,
        private cdr: ChangeDetectorRef,
        private zone: NgZone,
        private dragDropService: DragDropService,
        private formStateService: FormStateService,
        private router: Router,
        private fb: FormBuilder,
        private confirmationService: ConfirmationService
    ) {
        this.stateSubscription = new Subscription();
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: BeforeUnloadEvent) {
        if((this.formSettings.formName || this.formSettings.logoPreview || this.formSettings.coverPreview)) {
            $event.preventDefault();
            $event.returnValue = ''; // Required for Chrome to show prompt
        }
    }

    ngOnInit() {
        this.formStateService.resetToInitialState();
        this.isLoading = true;
    
        this.route.queryParams.subscribe((params) => {
            const formSettingsFromCreate = this.formBuilderService.formSettings.value;

            this.selectedCategory = formSettingsFromCreate?.category || params["category"] || "registration";
            this.previousSelectedCategory = this.selectedCategory
            this.editFormUuid = params["uuid"] || "";
            const cloneUuid = params['cloneUuid'] || '';
            this.cloneMode = !!cloneUuid;
            this.isEditMode = !!this.editFormUuid;
    
            if (this.isEditMode) {
                this.loadFormForEdit();
            } 
            else if (cloneUuid) {
                this.isEditMode = false;
                this.fetchAndPrefillClone(cloneUuid);
              }
            else {
                this.isEditMode = false;
                this.initializeEmptyState();
                this.fetchFields(this.selectedCategory);
            }
        });
    
        if (!this.isEditMode && !this.cloneMode) {
            this.initializeEmptyState();
        }

        this.searchForm = this.fb.group({
            search: [""]
        })

        this.customFieldForm = this.fb.group({
            label: ['', [Validators.required, Validators.maxLength(100)]],
            placeholder: ['', [Validators.maxLength(100)]],
            description: ['', [this.descriptionLengthValidator()]],
            type: ['', [Validators.required]],
            options: this.fb.array<FormGroup>([]),
            properties: this.fb.group({
                file_format: this.fb.control<string[]>([]),
                file_max_size: this.fb.control<string>('')
            })
        });
    }

    private fetchAndPrefillClone(uuid: string) {
        this.isLoading = true;
        this.formBuilderService.getFormFastApi(uuid)
          .pipe(finalize(() => this.isLoading = false))
          .subscribe({
            next: (res: any) => {
              this.resetFormState();
              this.prepopulateForClone(res.body);
            },
            error: () => {
              this.messageService.add({
                severity: 'error',
                summary: 'Clone Failed',
                detail: 'Unable to load form to clone'
              });
              this.initializeEmptyState();
              this.fetchFields(this.selectedCategory);
            }
          });
      }
      private prepopulateForClone(formData: any) {
        this.formSettings.formName    = formData.name + ' Copy';
        this.headerContent            = formData.header_content || '';
        this.footerContent            = formData.footer_content || '';      
        if (formData.logo) {
          this.formSettings.logoPreview = formData.logo;
          this.formSettings.logoImage   = this.extractFileNameFromUrl(formData.logo);
          this.logoBaseUrl              = formData.logo.replace(this.formSettings.logoImage, '');
        } else {
          this.formSettings.logoPreview = '';
          this.formSettings.logoImage   = '';
          this.logoBaseUrl              = '';
        }
        this.logoModified = false;      
        if (formData.cover_image) {
          this.formSettings.coverPreview = formData.cover_image;
          this.formSettings.coverImage   = this.extractFileNameFromUrl(formData.cover_image);
          this.coverBaseUrl              = formData.cover_image.replace(this.formSettings.coverImage, '');
        } else {
          this.formSettings.coverPreview = '';
          this.formSettings.coverImage   = '';
          this.coverBaseUrl              = '';
        }
        this.coverModified = false;      
        this.formLayoutSections = this.processEditFormSections(formData.form_fields || []);
        this.originalFormFields = JSON.parse(JSON.stringify(formData.form_fields || []));
        this.formFields         = this.processSections(this.originalFormFields);
        this.fieldsData         = JSON.parse(JSON.stringify(this.formFields));
        this.markUsedFieldsAsDisabled();
        this.fetchFields(this.selectedCategory);
        this.dropListIds.add('formLayout');
        this.dropListIds.add('availableSectionsList');
        this.formLayoutSections.forEach(section => {
          this.dropListIds.add(`sectionFields_${section.section_id}`);
        });
      }
      
      
    private loadFormForEdit() {
        this.isLoading = true;
        this.formBuilderService.getFormFastApi(this.editFormUuid).subscribe({
            next: (response: any) => {
                this.originalFormData = response.body;
                this.populateFormForEdit(this.originalFormData);
                this.fetchFields(this.selectedCategory);
            },
            error: (error: any) => {
                this.isLoading = false;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Failed to load form for editing",
                });
                this.router.navigate(
                    ["/settings"], 
                    { queryParams: { menu: "form-builder", category: this.selectedCategory }, replaceUrl: true }
                  );                  
            },
        });
    }
    
    private populateFormForEdit(formData: any) {
        this.formSettings.formName = formData.name || "";
        this.formSettings.bg_colour = formData.bg_colour;
        this.headerContent = formData.header_content || "";
        this.footerContent = formData.footer_content || "";
    
        if (formData.logo) {
            this.formSettings.logoPreview = formData.logo;
            this.formSettings.logoImage = this.extractFileNameFromUrl(formData.logo);
            this.logoBaseUrl = formData.logo.replace(this.formSettings.logoImage, "");
        }
    
        if (formData.cover_image) {
            this.formSettings.coverPreview = formData.cover_image;
            this.formSettings.coverImage = this.extractFileNameFromUrl(formData.cover_image);
            this.coverBaseUrl= formData.cover_image.replace(this.formSettings.coverImage, '');
        }
    
        if (formData.form_fields && formData.form_fields.length > 0) {
          this.formLayoutSections = this.processEditFormSections(formData.form_fields);
          this.dropListIds.add('formLayout');
          this.dropListIds.add('availableSectionsList');
          this.formLayoutSections.forEach(section => {
            this.dropListIds.add(`sectionFields_${section.section_id}`);
          });
        }
        this.selectedCategory = formData.form_type || "registration";
        this.previousSelectedCategory = this.selectedCategory;
    }
    
    private extractFileNameFromUrl(url: string): string {
        return url.split("/").pop() || "";
    }
    
    private processEditFormSections(formSections: any[]): FormSection[] {
        return formSections.map((section) => ({
            section_id: section.section_id || Date.now(),
            section_label: section.section_label,
            section_form_fields: this.processEditFormFields(section.section_form_fields),
            expanded: true,
        }));
    }
    
    private processEditFormFields(fields: any[]): FormField[] {
        const processedFields: FormField[] = [];
        fields.forEach((field) => {
            if (field.element_type === "group" && field.form_fields) {
                field.form_fields.forEach((groupField: any) => {
                    processedFields.push({
                        ...groupField,
                        id: groupField.id || Date.now(),
                        parent_group: field.name,
                        group_label: field.label,
                        element_type: "field",
                    });
                });
            } else {
                processedFields.push({
                    ...field,
                    id: field.id || Date.now(),
                    element_type: field.element_type || "field",
                });
            }
        });
        return processedFields;
    }
        
    private markUsedFieldsAsDisabled() {
        this.formLayoutSections.forEach((layoutSection) => {
            layoutSection.section_form_fields.forEach((usedField) => {
                this.fieldsData.forEach((section) => {
                    section.section_form_fields.forEach((field) => {
                        if (field.name === usedField.name) {
                            field["disabled"] = true;
                            field["hidden"] = true;
                        }
                    });
                });
    
                this.formFields.forEach((section) => {
                    section.section_form_fields.forEach((field) => {
                        if (field.name === usedField.name) {
                            field["disabled"] = true;
                            field["hidden"] = true;
                        }
                    });
                });

                this.formCustomFields.forEach((section) => {
                    section.section_form_fields.forEach((field) => {
                        if(field.name === usedField.name && usedField.section_label?.toLowerCase() === "custom fields") {
                            field['disabled'] = true;
                        }
                    })
                })
            });
        });
    }
    
    private initializeEmptyState() {
        const formSettingsFromCreate = this.formBuilderService.formSettings.value;

        this.formSettings = {
            formName: formSettingsFromCreate.formName || '',
            logoImage: formSettingsFromCreate.logoImage || '',
            coverImage: formSettingsFromCreate.coverImage || '',
            logoPreview: formSettingsFromCreate.logoPreview || '',
            coverPreview: formSettingsFromCreate.coverPreview || '',
            touched: false,
            bg_colour: null,
        };
        this.formLayoutSections = [];
        this.headerContent = '';
        this.footerContent = '';
        this.selectedField = null;
        this.selectedSection = null;
        this.draggedField = null;
        this.selectedTab = 'sections';
        this.showHeader = false;
        this.showFooter = false;

        if(!Object.keys(formSettingsFromCreate).length && !this.isEditMode && !this.cloneMode) {
            this.showFormDetailsEdit = true;
        }

        this.updateFormStateWithDebounce();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.formLayout && this.availableSections) {
                this.formLayout.connectedTo = ['availableSectionsList'];
                this.availableSections.connectedTo = ['formLayout'];
                this.dropListIds.add('formLayout');
                this.dropListIds.add('availableSectionsList');
            }
        });
    }

    private resetFormState() {
        this.formStateService.resetToInitialState();
        this.previewFormData = null;
        this.initializeEmptyState();
        this.formFields = [];
        this.fieldsData = [];
        this.originalFormFields = [];
        this.originalFieldsData = [];
        this.dropListIds = new Set(["formLayout", "availableSectionsList"]);
        this.isEditMode = false;
        this.editFormUuid = "";
        this.originalFormData = null;
        this.cdr.detectChanges();
    }
    

    ngOnDestroy() {
        if (this.stateSubscription) {
            this.stateSubscription.unsubscribe();
        }
    }

    fetchFields(category: string, trackChanges: boolean = true) {
        this.isLoading = true;
        this.formBuilderService.getFormFieldsFastApi(category).subscribe({
            next: (response: any) => {
                this.isLoading = false;
                this.originalFormFields = JSON.parse(JSON.stringify(response.body.form_fields));
                this.formFields = this.processSections(response.body.form_fields);
                this.fieldsData = JSON.parse(JSON.stringify(this.formFields));
                this.originalFieldsData = JSON.parse(JSON.stringify(response.body.form_fields));
                this.markUsedFieldsAsDisabled();

                if (this.selectedCategory === "registration") {
                    const availableSections = this.availableFormFields;
                    const personalInfoSection = availableSections.find((section) => section.section_label.toLowerCase().trim() === "personal info");
                    if (personalInfoSection) {
                        const sectionCopy: FormSection = {
                            section_id: Date.now(),
                            section_label: personalInfoSection.section_label,
                            section_form_fields: personalInfoSection.section_form_fields.filter((field) => {
                                if(field.name === "email_id" || field.name === "confirm_email_id") {
                                    field.is_required = true;
                                }

                                return field.name === "email_id" || field.name === "confirm_email_id";
                            }) || [],
                            expanded: true
                        };
                        this.formLayoutSections = [sectionCopy];
                        this.registerDropList(`sectionFields_${sectionCopy.section_id}`);

                        this.fieldsData.forEach((section) => {
                            if(section.section_label.toLowerCase() === "personal info") {
                                section.section_form_fields = section.section_form_fields.filter((field) => {
                                    return field.name !== "email_id" && field.name !== "confirm_email_id"
                                })
                            }
                        })
                    }
                }

                if (this.selectedCategory === "offer") {
                    const availableSections = this.availableFormFields;
                    const personalInfoSection = availableSections.find((section) => section.section_label.toLowerCase().trim() === "info");
                    if (personalInfoSection) {
                        const sectionCopy: FormSection = {
                            section_id: Date.now(),
                            section_label: personalInfoSection.section_label,
                            section_form_fields: personalInfoSection.section_form_fields.filter((field) => {
                                if(field.name === "offer_acceptance") {
                                    field.is_required = true;
                                }

                                return field.name === "offer_acceptance";
                            }) || [],
                            expanded: true
                        };
                        this.formLayoutSections = [sectionCopy];
                        this.registerDropList(`sectionFields_${sectionCopy.section_id}`);

                        this.fieldsData.forEach((section) => {
                            if(section.section_label.toLowerCase() === "info") {
                                section.section_form_fields = section.section_form_fields.filter((field) => {
                                    return field.name !== "offer_acceptance"
                                })
                            }
                        })
                    }
                }

                if (this.selectedCategory === "feedback") {
                    let alreadyHasOverallAssessmentSection = false;
                    let alreadyHasFinalRecommendationInOverallAssessment = false;
                    let alreadyHasFinalRecommendationInOtherSection: FormField | null = null;

                    this.formLayoutSections?.forEach((section) => {
                        if(section.section_label?.toLowerCase() === "overall assessment") {
                            alreadyHasOverallAssessmentSection = true;
                        }

                        section.section_form_fields?.forEach((field) => {
                            if (field.name === "final_recommendation") {
                                if(section.section_label?.toLowerCase() === "overall assessment") {
                                    alreadyHasFinalRecommendationInOverallAssessment = true;
                                }

                                if(section.section_label?.toLowerCase() !== "overall assessment") {
                                    alreadyHasFinalRecommendationInOtherSection = field;
                                }
                            }
                        })
                    })

                    if (alreadyHasFinalRecommendationInOtherSection) {
                        this.formLayoutSections?.forEach((section) => {
                            section.section_form_fields = section.section_form_fields.filter((field) => {
                                return field.name !== "final_recommendation"
                            })
                        })
                    }

                    if (!alreadyHasOverallAssessmentSection) {
                        const overallAssessmentSection = this.availableFormFields.find((section) => section.section_label.toLowerCase().trim() === "overall assessment");
                        const candidateInfoSection = this.availableFormFields.find((section) => section.section_label.toLowerCase().trim() === "candidate information");
                        if (overallAssessmentSection) {
                            const sectionCopy: FormSection = {
                                section_id: Date.now(),
                                section_label: overallAssessmentSection.section_label,
                                section_form_fields: alreadyHasFinalRecommendationInOtherSection ? [alreadyHasFinalRecommendationInOtherSection] : candidateInfoSection?.section_form_fields.filter((field) => {
                                    if (field.name === "final_recommendation") {
                                        field.is_required = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.is_required : true;
                                        field.placeholder = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.placeholder : field.placeholder;
                                        field.description = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.description : field.description;
                                        field.section_id = overallAssessmentSection.section_id;
                                        field.section_label = overallAssessmentSection.section_label;
                                    }

                                    return field.name === "final_recommendation";
                                }) || [],
                                expanded: true
                            };

                            this.formLayoutSections = [sectionCopy, ...this.formLayoutSections];
                            this.registerDropList(`sectionFields_${sectionCopy.section_id}`);
                        }
                    }

                    if (alreadyHasOverallAssessmentSection && !alreadyHasFinalRecommendationInOverallAssessment) {
                        const candidateInfoSection = this.availableFormFields.find((section) => section.section_label.toLowerCase().trim() === "candidate information");
                        this.formLayoutSections?.forEach((section) => {
                            if (section.section_label?.toLowerCase() === "overall assessment") {
                                section.section_form_fields = alreadyHasFinalRecommendationInOtherSection ? [alreadyHasFinalRecommendationInOtherSection, ...section.section_form_fields] : [...candidateInfoSection?.section_form_fields.filter((field) => {
                                    if (field.name === "final_recommendation") {
                                        field.is_required = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.is_required : true;
                                        field.placeholder = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.placeholder : field.placeholder;
                                        field.description = alreadyHasFinalRecommendationInOtherSection ? alreadyHasFinalRecommendationInOtherSection.description : field.description;
                                        field.section_id = section.section_id;
                                        field.section_label = section.section_label;
                                    }

                                    return field.name === "final_recommendation";
                                }) || [], ...section.section_form_fields]
                            }
                        })
                    }

                    this.fieldsData.forEach((section) => {
                        if(section.section_label.toLowerCase() === "candidate information") {
                            section.section_form_fields = section.section_form_fields.filter((field) => {
                                return field.name !== "final_recommendation"
                            })
                        }
                    })
                }

                if(trackChanges) {      
                    this.trackChanges();
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch fields' });
            }
        });
    }

    onCategoryChange(dialogTarget: any, event: any) {
        if (this.isEditMode) {
            this.messageService.add({
                severity: "warn",
                summary: "Cannot Change Category",
                detail: "Category cannot be changed while editing a form",
            });
            return;
        }
        
        if (this.formLayoutSections.length) {
            this.confirmationService.confirm({
                target: dialogTarget,
                message: 'Changing the category will remove all added sections and fields. Are you sure you want to continue?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.confirmOnCategoryChange(event);
                },
                reject: () => {
                    this.selectedCategory = this.previousSelectedCategory;
                },
                dismissableMask: false,
                closeOnEscape: false
            }); 
            return;
        }

        this.confirmOnCategoryChange(event);
    }

    confirmOnCategoryChange(event: any) {
        // this.resetFormState();
        this.formLayoutSections = [];
        this.selectedCategory = event.value;
        this.previousSelectedCategory = this.selectedCategory;
        this.fetchFields(this.selectedCategory, false);
        this.fetchedCustomFields = false;
        if(this.selectedTab === "custom_fields") {
            this.fetchCustomFields();
        }
        // this.router.navigate([], {
        //     relativeTo: this.route,
        //     queryParams: { category: this.selectedCategory },
        //     queryParamsHandling: "merge",
        // });
        this.messageService.add({
            severity: "info",
            summary: "Category Changed",
            detail: "Form builder has been reset for new category",
        });
    }
    

    private processSections(sections: any[]): FormSection[] {
        return sections.map(section => ({
            ...section,
            expanded: true,
            section_form_fields: this.flattenFields(
                section.section_form_fields,
                { id: section.section_id, label: section.section_label }
            ).map(field => ({
                ...field,
                disabled: false
            }))
        }));
    }

    private flattenFields(fields: any[], sectionInfo?: { id: number, label: string }): FormField[] {
        if (!fields) return [];

        return fields.reduce((acc: FormField[], field) => {
            if (field.element_type === 'group' && field.form_fields) {
                const nestedFields = field.form_fields.map((nestedField: any) => ({
                    ...nestedField,
                    parent_group: field.name,
                    group_label: field.label,
                    original_id: nestedField.id,
                    id: `${field.id}_${nestedField.id}`,
                    max_duplicates: field.max_duplicates,
                    type: nestedField.type || field.type,
                    element_type: nestedField.element_type || 'field',
                    section_id: sectionInfo?.id,
                    section_label: sectionInfo?.label,
                    is_required: false,
                }));
                return [...acc, ...nestedFields];
            } else {
                return [...acc, {
                    ...field,
                    section_id: sectionInfo?.id,
                    section_label: sectionInfo?.label,
                    is_required: false,
                }];
            }
        }, []);
    }

    toggleSection(section: any) {
        section.expanded = !section.expanded;
    }

    selectTab(selectedTab: string) {
        this.selectedTab = selectedTab;
        this.searchForm.reset();

        if(selectedTab === "custom_fields") {
            this.fetchCustomFields();
        }
    }

    drop(event: CdkDragDrop<any[]>) {
        if (!event?.container?.data || !event?.previousContainer?.data) {
            return;
        }

        this.zone.run(() => {
            if (event.previousContainer === event.container) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

                if (event.container.id.startsWith('sectionFields_')) {
                    this.updateFormStateWithDebounce();
                }
                return;
            }

            if (event.container.id === 'formLayout') {
                this.handleSectionDrop(event);
            } else if (event.container.id.startsWith('sectionFields_')) {
                this.handleFieldDrop(event);
            }
        });
    }

    private handleSectionDrop(event: CdkDragDrop<any[]>) {
        this.dragDropService.setDragging(true);

        try {
            const draggedSection = event.previousContainer.data[event.previousIndex];
            if (!draggedSection) return;

            const sectionCopy: FormSection = {
                section_id: Date.now(),
                section_label: draggedSection.section_label,
                section_form_fields: [],
                expanded: true
            };

            this.formLayoutSections = [
                ...this.formLayoutSections.slice(0, event.currentIndex),
                sectionCopy,
                ...this.formLayoutSections.slice(event.currentIndex)
            ];

            this.formFields = this.formFields.filter(
                section => section.section_id !== draggedSection.section_id
            );

            this.registerDropList(`sectionFields_${sectionCopy.section_id}`);

        } catch (error) {
            console.error('Section drop error:', error);
        } finally {
            this.dragDropService.setDragging(false);
            this.updateFormStateWithDebounce();
        }
    }
    get availableFormFields(): FormSection[] {
        const filterFieldsBasedOnSearch = (fields: FormSection[]) => {
            return fields.filter((field) => {
                if(field.section_label.toLowerCase().includes(this.searchForm.get("search")?.value ?? "")) {
                    return field;
                }

                return null;
            })
        }

        if (!this.isEditMode) {
            let fields = this.formFields.filter(section => 
                section.section_form_fields.filter(field => !field['hidden']).length > 0
            );
            fields = filterFieldsBasedOnSearch(fields);
        }
        
        const usedSectionLabels = new Set(
            this.formLayoutSections.map(section => section.section_label)
        );        
        let fields = this.formFields.filter(section => 
            !usedSectionLabels.has(section.section_label) && 
            section.section_form_fields.some(field => !field['hidden'])
        );
        fields = filterFieldsBasedOnSearch(fields);

        return fields;
    }
    
    private disableFieldInSections(field: FormField) {
        [this.fieldsData, this.formFields].forEach(sections =>
        sections.forEach(sec =>
            sec.section_form_fields.forEach(f => {
            if (f.id === field.id) {
                f['disabled'] = true;
                f['hidden']   = true;
            }
            })
        )
        );

        if(field.section_label?.toLowerCase() === "custom fields") {
            this.formCustomFields.forEach((section) => {
                section.section_form_fields.forEach((f) => {
                    if(f.id === field.id) {
                        f["disabled"] = true;
                    }
                })
            })
        }
    }
    
    private handleFieldDrop(event: CdkDragDrop<any[]>) {
        try {
        const draggedField: FormField = event.item.data;  
        const targetSectionId = event.container.id.replace('sectionFields_', '');
        const targetSection = this.formLayoutSections.find(
            s => s.section_id.toString() === targetSectionId
        );
        if (!targetSection) throw new Error('Target section not found');  
        const fieldCopy = this.createFieldCopy(draggedField);
        targetSection.section_form_fields.splice(event.currentIndex, 0, fieldCopy);  
        const sourceSectionId = event.previousContainer.id.replace('sectionFields_', '');
        const sourceSection = this.formLayoutSections.find(s => s.section_id.toString() === sourceSectionId);
        if (sourceSection) {
            const idx = sourceSection.section_form_fields.findIndex(f => f.id === draggedField.id);
            if (idx > -1) {
            sourceSection.section_form_fields.splice(idx, 1);
            }
        }  
        this.disableFieldInSections(draggedField);  
        this.updateFormStateWithDebounce();
    
        } catch (error) {
        console.error('Field drop error:', error);
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error dropping field'
        });
        }
    }

    private createFieldCopy(field: FormField): FormField {
        const copy = {
            ...JSON.parse(JSON.stringify(field)),
            id: field.original_id ? `${field.parent_group}_${Date.now()}` : Date.now()
        };

        if (field.parent_group) {
            copy.parent_group = field.parent_group;
            copy.group_label = field.group_label;
            copy.original_id = field.original_id;
        }

        return copy;
    }

    deleteSection(index: number) {
        const deletedSection = this.formLayoutSections[index];

        if (deletedSection.section_form_fields && deletedSection.section_form_fields.length > 0) {
            deletedSection.section_form_fields.forEach(field => {
                if (!field.section_id) {
                    console.error('Field has no section_id:', field);
                    return;
                }

                const targetSection = this.fieldsData.find(s => s.section_id === field.section_id);

                if (targetSection) {
                    const originalField = this.findFieldInOriginalData(targetSection, field);
                    if (originalField) {
                        const insertIndex = this.findInsertIndexByOrderNo(field, field.section_id);

                        targetSection.section_form_fields.splice(insertIndex, 0, {
                            ...field,
                            ['disabled']: false
                        });

                        const formFieldsSection = this.formFields.find(s => s.section_id === field.section_id);
                        if (formFieldsSection) {
                            formFieldsSection.section_form_fields.splice(insertIndex, 0, {
                                ...originalField,
                                ['disabled']: false
                            });
                        }

                        this.enableFieldInSections(field);
                    }
                }
            });
        }
        this.formLayoutSections.splice(index, 1);

        if (this.isEditMode) {
            const originalSection = this.originalFormFields.find(
                section => section.section_label === deletedSection.section_label
            );

            if (originalSection) {
                const existingSection = this.formFields.find(
                    section => section.section_label === deletedSection.section_label
                );
                if (!existingSection) {
                    const restoredSection = {
                        ...JSON.parse(JSON.stringify(originalSection)),
                        expanded: true
                    };    
                    const originalIndex = this.originalFormFields.findIndex(
                        section => section.section_label === deletedSection.section_label
                    );    
                    this.formFields.splice(originalIndex, 0, restoredSection);
                }
            }
        } else {
            const originalSection = this.originalFormFields.find(
                section => section.section_label === deletedSection.section_label
            );
    
            if (originalSection) {
                const restoredSection = {
                    ...JSON.parse(JSON.stringify(originalSection)),
                    expanded: true
                };

                const originalIndex = this.originalFormFields.findIndex(
                    section => section.section_label === deletedSection.section_label
                );

                this.formFields.splice(originalIndex, 0, restoredSection);
            }
        }

        if (this.selectedSection?.section_id === deletedSection.section_id) {
            this.clearSelection();
        }

        this.handleRemovedDependencyFields();
        this.updateFormStateWithDebounce();
    }

    private enableFieldInSections(field: FormField): void {
        this.fieldsData.forEach(section => {
            section.section_form_fields.forEach(f => {
                if (f.name === field.name) {
                    f['disabled'] = false;
                    f['hidden'] = false;
                }
            });
        });

        this.formFields.forEach(section => {
            section.section_form_fields.forEach(f => {
                if (f.name === field.name) {
                    f['disabled'] = false;
                    f['hidden'] = false;
                }
            });
        });
    }
    getVisibleFields(section: FormSection): FormField[] {
        return section.section_form_fields
            ? section.section_form_fields.filter((f: FormField) => !f['hidden'] && f.label.toLowerCase().includes(this.searchForm.get("search")?.value ?? ""))
            : [];
    }    
    deleteField(sectionIndex: number, fieldIndex: number) {
        const deletedField = this.formLayoutSections[sectionIndex].section_form_fields[fieldIndex];

        if (!deletedField.section_id) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Field has no section ID'
            });
            return;
        }

        const targetSection = this.fieldsData.find(s => s.section_id === deletedField.section_id);
        if (targetSection) {
            const originalField = this.findFieldInOriginalData(targetSection, deletedField);

            if (originalField) {
                const insertIndex = this.findInsertIndexByOrderNo(deletedField, deletedField.section_id);

                targetSection.section_form_fields.splice(insertIndex, 0, {
                    ...deletedField,
                    ['disabled']: false
                });

                const formFieldsSection = this.formFields.find(s => s.section_id === deletedField.section_id);
                if (formFieldsSection) {
                    formFieldsSection.section_form_fields.splice(insertIndex, 0, {
                        ...originalField,
                        ['disabled']: false
                    });
                }
            }
        }

        if(deletedField.section_label?.toLowerCase() === "custom fields") {
            const formFieldsSection = this.formCustomFields.find(s => s.section_id === deletedField.section_id);
            if (formFieldsSection) {
                formFieldsSection.section_form_fields.forEach((f) => {
                    f["disabled"] = false;
                })
            }
        }

        this.formLayoutSections[sectionIndex].section_form_fields.splice(fieldIndex, 1);

        this.handleRemovedDependencyFields();
        this.updateFormStateWithDebounce();
    }

    private findFieldInOriginalData(section: FormSection, field: FormField): FormField | null {
        const originalSection = this.originalFieldsData.find(s => s.section_id === section.section_id);
        if (!originalSection) return null;

        const directField = originalSection.section_form_fields.find(f =>
            f.name === field.name
        );
        if (directField) return directField;

        for (const sectionField of originalSection.section_form_fields) {
            if (sectionField.element_type === 'group' && sectionField.form_fields) {
                const nestedField = sectionField.form_fields.find(f =>
                    f.name === field.name
                );
                if (nestedField) return nestedField;
            }
        }
        return null;
    }

    private findInsertIndexByOrderNo(field: FormField, sectionId: number | undefined): number {
        if (!sectionId) return 0;

        const originalSection = this.originalFieldsData.find(s => s.section_id === sectionId);
        if (!originalSection) return 0;

        const originalFieldIndex = originalSection.section_form_fields.findIndex(f =>
            f.name === field.name
        );

        if (originalFieldIndex === -1) return 0;

        const fieldsDataSection = this.fieldsData.find(s => s.section_id === sectionId);
        if (!fieldsDataSection) return 0;

        return Math.min(originalFieldIndex, fieldsDataSection.section_form_fields.length);
    }

    getConnectedSectionsList(): string[] {
        return ['formLayout'];
    }

    getFieldDropZones(): string[] {
        const sectionDropZones = this.formLayoutSections.map(
            section => `sectionFields_${section.section_id}`
        );
        return sectionDropZones;
    }

    getConnectedFieldsList(sectionId: number): string[] {
        const validIds = Array.from(this.dropListIds)
            .filter(id => id.startsWith('sectionFields_') && id !== `sectionFields_${sectionId}`);
        return validIds;
    }

    registerDropList(id: string): void {
        this.dropListIds.add(id);
    }

    unregisterDropList(id: string): void {
        this.dropListIds.delete(id);
    }

    selectField(field: FormField, section: FormSection) {
        this.selectedField = field;
        this.selectedSection = section;
        
        this.showFieldPropertiesDependenciesStructure();

        this.showFieldProperties = true;

        if (field.type === 'File') {
            this.ensureFileProperties(field);
        }
    }

    showFieldPropertiesDependenciesStructure() {
        if(this.selectedField && this.selectedField["dependencies"] && Array.isArray(this.selectedField["dependencies"])) {
            const updatedDependencies: any = {};
            this.selectedField["dependencies"].forEach((dep) => {
                updatedDependencies[dep.option] = dep.show_fields;
            })
            this.selectedField["dependencies"] = updatedDependencies;
        }
    }

    ensureFileProperties(field?: FormField) {
        const targetField = field || this.selectedField;
        if (!targetField) return;

        if (!targetField.properties) {
            targetField.properties = {
                file_format: [],
                file_max_size: '2MB'
            };
        } else {
            if (!targetField.properties.file_format) {
                targetField.properties.file_format = [];
            }
            if (!targetField.properties.file_max_size) {
                targetField.properties.file_max_size = '2MB';
            }
        }
    }

    updateFieldProperty(field: FormField, property: string, value: any) {
        if (!field) return;

        if (property.includes('.')) {
            const [parent, child] = property.split('.');
            if (!field[parent]) {
                field[parent] = {};
            }
            field[parent][child] = value;
        } else {
            field[property] = value;
        }

        this.updateFormStateWithDebounce();
    }

    updateFileFormat(value: string[]) {
        if (this.selectedField && this.selectedField.properties) {
            this.selectedField.properties.file_format = value;
            this.updateFieldProperty(this.selectedField, 'properties.file_format', value);
        }
    }

    updateFileMaxSize(value: string) {
        if (this.selectedField && this.selectedField.properties) {
            this.selectedField.properties.file_max_size = value;
            this.updateFieldProperty(this.selectedField, 'properties.file_max_size', value);
        }
    }

    clearSelection() {
        this.selectedField = null;
        this.selectedSection = null;
    }

    addOption(field: FormField) {
        if (!field.options) {
            field.options = [];
        }
        field.options.push({ label: '', value: '' });
        this.updateFormStateWithDebounce();
    }

    removeOption(field: FormField, index: number) {
        if (field.options) {
            const removedOption = field.options.splice(index, 1);

            if(removedOption) {
                const option = removedOption[0];
                const dependencies = this.selectedField?.["dependencies"];
                if(dependencies) {
                    delete field["dependencies"][option.value];
                }
            }
        }
        this.updateFormStateWithDebounce();
    }

    addNewOption() {
        if (!this.selectedField) return;

        if (!this.selectedField.options) {
            this.selectedField.options = [];
        }

        let newOption: FieldOption;

        if (this.selectedField.type === 'Checkbox') {
            this.selectedField.options.push({
                label: '',
                value: 'true'
            });
        } else {
            newOption = {
                label: '',
                value: ''
            };
            this.selectedField.options.push(newOption);
        }
    }

    validateOption(index: number, field: 'label' | 'value', newValue: any) {
        console.log('newValue: ', newValue);
        if (!this.selectedField?.options) return;
    
        const options = this.selectedField.options;
        const currentOption = options[index];
    
        if (field === 'label') {
            if (newValue.length > 216) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Label cannot exceed 216 characters'
                });
                return;
            }
            
            const oldValue = currentOption.value;
            const existingDependencies = this.selectedField['dependencies']?.[oldValue];
            if(existingDependencies) {
                delete this.selectedField['dependencies']?.[oldValue];
            }

            if (this.selectedField.type === 'Dropdown' || this.selectedField.type === 'Radio') {
                currentOption.label = newValue;
                currentOption.value = this.generateValueFromLabel(newValue);
            } else if (this.selectedField.type === 'Checkbox') {
                currentOption.label = newValue;
                currentOption.value = this.generateValueFromLabel(newValue);
            }

            if(existingDependencies) {
                this.selectedField['dependencies'][currentOption.value] = existingDependencies;
            }
        }
        
        if (field === 'value' && this.selectedField.type === 'Checkbox') {
            currentOption.value = newValue;
        }
    
        this.updateFormStateWithDebounce();
    }

    private generateValueFromLabel(label: string): string {
        return label.toLowerCase().replace(/\s+/g, '_');
    }

    isCheckboxType(): boolean {
        return this.selectedField?.type === 'Checkbox';
    }

    isDropdownOrRadioType(): boolean {
        return this.selectedField?.type === 'Dropdown' || this.selectedField?.type === 'Radio';
    }

    toggleHeader() {
        this.showHeader = !this.showHeader;
    }

    toggleFooter() {
        this.showFooter = !this.showFooter;
    }

    adjustTextareaHeight(event: any) {
        const textarea = event.target;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }

    onFileSelected(event: any, type: 'logo' | 'cover') {
        this[`${type}Modified`] = true;
        const file = event.target.files[0];
        if (!file) return;

        const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!validTypes.includes(file.type)) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid File',
                detail: 'Please upload only JPG, JPEG or PNG files'
            });
            return;
        }

        const maxSize = type === 'logo' ? 500 * 1024 : 2 * 1024 * 1024;
        if (file.size > maxSize) {
            this.messageService.add({
                severity: 'error',
                summary: 'File Too Large',
                detail: `${type === 'logo' ? 'Logo' : 'Cover'} image must be less than ${type === 'logo' ? '500KB' : '2MB'}`
            });
            return;
        }

        const fileName = this.generateFileName(file);
        const renamedFile = new File([file], fileName, {
            type: file.type,
            lastModified: file.lastModified,
        });

        this.handleImageUpload(renamedFile, fileName, type);
    }

    private generateFileName(file: any): string {
        let fileName = file.name.split(".");
        let fileExtension = fileName.pop();
        const timestamp = new Date().getTime();
        return `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
    }

    private handleImageUpload(file: File, fileName: string, type: 'logo' | 'cover') {
        if (type === 'logo') {
            this.uploadingLogo = true;
        } else {
            this.uploadingCover = true;
        }

        const filePath = `form-images/${type}/${fileName}`;
        const payload = {
            file_path: filePath,
            bucket_type: 'public',
            origin:"form_builder"
        };

        this.fileUploadService.getSignedUrlGCS(payload, false).subscribe({
            next: (response: any) => {
                if (response?.body?.signed_url) {
                    this.bucketUrl = response?.body?.signed_url.split(fileName)[0];
                    this.uploadFileToGCS(response.body.signed_url, file, filePath, fileName, type);
                } else {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Invalid signed URL received'
                    });
                    this.resetUploadState(type);
                }
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error getting signed URL'
                });
                this.resetUploadState(type);
            }
        });
    }

    private uploadFileToGCS(signedUrl: string, file: File, filePath: string, fileName: string, type: 'logo' | 'cover') {
        this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
            next: (response: any) => {
                if (response?.status === "success") {
                    const reader = new FileReader();
                    reader.onload = (e: any) => {
                        if (type === 'logo') {
                            this.formSettings.logoPreview = e.target.result;
                            this.formSettings.logoImage = fileName;
                        } else {
                            this.formSettings.coverPreview = e.target.result;
                            this.formSettings.coverImage = fileName;
                        }

                        this.updateFormStateWithDebounce();
                    };
                    reader.readAsDataURL(file);

                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: `${type === 'logo' ? 'Logo' : 'Cover'} image uploaded successfully`
                    });
                    this.resetUploadState(type);
                }
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error uploading file'
                });
                this.resetUploadState(type);
            }
        });
    }

    private resetUploadState(type: 'logo' | 'cover') {
        if (type === 'logo') {
            this.uploadingLogo = false;
        } else {
            this.uploadingCover = false;
        }
    }

    generateUniqueId(): number {
        return Date.now() + Math.floor(Math.random() * 10000);
    }

    groupSectionFields(sectionFields: any[], mapDependencies: boolean = false): any[] {
        const result: any[] = [];
        const groupMap: { [label: string]: any } = {};

        sectionFields.forEach(field => {
            if (mapDependencies && field["dependencies"] && !Array.isArray(field["dependencies"])) {
                const newArray: any[] = [];
                Object.entries(field["dependencies"]).map((val) => {
                    const [key, value]: [string, any] = val;
                    if(value?.length) {
                        newArray.push({ option: key, show_fields: value });
                    }
                })
                if(newArray.length) {
                    field["dependencies"] = newArray;
                } else {
                    delete field["dependencies"]
                }
            }

            if(mapDependencies && field["dependencies"] && Array.isArray(field["dependencies"])) {
                field["dependencies"] = field["dependencies"].filter((dep) => dep.show_fields.length);
            }

            if(mapDependencies && field["dependencies"] && Array.isArray(field["dependencies"]) && !field["dependencies"].length) {
                delete field["dependencies"];
            }

            const groupName = field.group_label;
            if (groupName) {
                if (!groupMap[groupName]) {
                    const groupObj = {
                        id: field.id || Date.now() + Math.floor(Math.random() * 10000),
                        name: groupName,
                        label: groupName,
                        order_no: field.order_no ?? null,
                        form_fields: [],
                        element_type: 'group',
                        max_duplicates: 0
                    };
                    groupMap[groupName] = groupObj;
                    result.push(groupObj);
                }
                groupMap[groupName].form_fields.push({
                    ...field,
                    id: field.id || Date.now() + Math.floor(Math.random() * 10000),
                    element_type: 'field'
                });
            } else {
                result.push({
                    ...field,
                    id: field.id || Date.now() + Math.floor(Math.random() * 10000),
                    element_type: 'field'
                });
            }
        });

        return result;
    }

    validateForm(): { isValid: boolean, errors: string[] } {
        if (!this.formSettings.formName?.trim()) {
            return {
                isValid: false,
                errors: ['Form name is required']
            };
        }

        if (this.headerContent === undefined || this.headerContent === null || this.headerContent === '') {
            return {
                isValid: false,
                errors: ['Header content must be defined']
            };
        }

        if (this.footerContent === undefined || this.footerContent === null || this.footerContent === '') {
            return {
                isValid: false,
                errors: ['Footer content must be defined']
            };
        }

        if (this.headerContent.trim().length > 254) {
            return {
                isValid: false,
                errors: ['Header content exceeds maximum length of 254 characters']
            };
        }

        if (!this.formSettings.logoImage) {
            return {
                isValid: false,
                errors: ['Logo image is required']
            };
        }

        if (this.footerContent.trim().length > 254) {
            return {
                isValid: false,
                errors: ['Footer content exceeds maximum length of 254 characters']
            };
        }

        if (!this.formLayoutSections || this.formLayoutSections.length === 0) {
            return {
                isValid: false,
                errors: ['At least one section is required']
            };
        } else {
            const hasFields = this.formLayoutSections.some(section =>
                section.section_form_fields && section.section_form_fields.length > 0
            );
            if (!hasFields) {
                return {
                    isValid: false,
                    errors: ['At least one section must contain fields']
                };
            }
        }

        return {
            isValid: true,
            errors: []
        };
    }

    /** Inline hint under the Content box, e.g. "Mark Father/Guardian field as required." */
    requiredFieldHint(text: string | undefined | null): string {
        const fields = this.optionalReferencedFieldsIn(text);
        if (!fields.length) { return ''; }
        return `Mark ${this.joinLabels(fields)} ${fields.length === 1 ? 'field' : 'fields'} as required.`;
    }

    /** "A", "A and B", "A, B and C" — reads naturally inside a sentence. */
    private joinLabels(labels: string[]): string {
        if (labels.length <= 1) { return labels[0] || ''; }
        return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
    }

    /**
     * Warn, without blocking, when a Paragraph fills in fields the candidate could leave
     * empty. The author may have done it deliberately, but far more often they simply
     * forgot to mark the field Required.
     */

    private warnAboutPlaceholderIssues(): boolean {
        const unresolved = this.paragraphsWithUnresolvedPlaceholders();
        unresolved.forEach((issue) => {
            this.messageService.add({
                severity: 'warn',
                summary: 'Check placeholders',
                detail: `${issue.tokens.join(', ')} in the ${issue.field} `
                    + `${issue.tokens.length === 1 ? 'does' : 'do'} not match any field on this form, `
                    + `so ${issue.tokens.length === 1 ? 'it' : 'they'} will appear blank.`,
                life: 8000
            });
        });

        const optionalReferences = this.paragraphsWithOptionalReferences();
        optionalReferences.forEach((issue) => {
            const fields = this.joinLabels(issue.optional);
            const isOne = issue.optional.length === 1;
            this.messageService.add({
                severity: 'warn',
                summary: 'Check required fields',
                detail: `${fields} ${isOne ? 'is' : 'are'} used in the ${issue.field}. `
                    + `Please mark ${isOne ? 'this field' : 'these fields'} as Required.`,
                life: 8000
            });
        });
        return unresolved.length > 0 || optionalReferences.length > 0;
    }

    saveForm() {
        const validation = this.validateForm();
        const logoUrl = this.logoModified
        ? this.bucketUrl + this.formSettings.logoImage
        : this.formSettings.logoPreview;

        const coverUrl = this.coverModified
        ? this.bucketUrl + this.formSettings.coverImage
        : this.formSettings.coverPreview;

        if (!validation.isValid) {
            validation.errors.forEach(error => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: error
                });
            });
            return;
        }

        // Warned rather than errored, but still blocking: a declaration that can be
        // submitted with blanks in it is not a valid consent.
        if (this.warnAboutPlaceholderIssues()) {
            return;
        }

        const formPayload = {
            name: this.formSettings.formName.trim(),
            label: this.formSettings.formName.toLowerCase().replace(/\s+/g, '_'),
            logo: logoUrl,
            cover_image: coverUrl,
            header_content: this.headerContent?.trim() || null,
            footer_content: this.footerContent?.trim() || null,
            form_type: this.selectedCategory,
            form_fields: this.formLayoutSections.map(section => ({
                section_id: section.section_id,
                section_label: section.section_label.trim(),
                section_form_fields: this.groupSectionFields(section.section_form_fields, true)
            })),
            logo_modified: this.logoModified,
            cover_modified: this.coverModified,
            bg_colour: this.formSettings.bg_colour
        };

        let hasEmptySections: boolean = false;
        formPayload?.form_fields?.forEach((section: any) => {
            if(!section?.section_form_fields?.length) {
                hasEmptySections = true;
            }
        })

        if(hasEmptySections) {
            this.messageService.add({
                severity: 'error',
                summary: 'Validation Error',
                detail: "One or more sections are empty. Please ensure all sections contain at least one field before proceeding."
            });
            return;
        }

        this.previewFormData = formPayload;
        this.showPreviewDialog = true;
    }
      
      
      confirmSave() {
        if (!this.previewFormData) return;
        this.savingForm = true;
        const apiPayload = {
            ...this.previewFormData,
            logo: this.prepareImageForSave('logo'),
            cover_image: this.prepareImageForSave('cover'),
            logo_modified: this.logoModified,
            cover_modified: this.coverModified
        };
    
        const apiCall = this.isEditMode 
            ? this.formBuilderService.updateFormFastApi(this.editFormUuid, apiPayload)
            : this.formBuilderService.createNewFormFastApi(apiPayload);
    
        apiCall.subscribe({
            next: (response: any) => {
                this.showPreviewDialog = false;
                const actionText = this.isEditMode ? 'updated' : 'saved';
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: `${this.selectedCategory.charAt(0).toUpperCase() + this.selectedCategory.slice(1)} Form ${actionText} successfully`,
                });
                
                if (!this.isEditMode) {
                    this.resetFormState();
                    this.fetchFields(this.selectedCategory);
                }
                this.savingForm = false;
                this.router.navigate(
                    ["/settings"], 
                    { queryParams: { menu: "form-builder", category: this.selectedCategory }, replaceUrl: true }
                  );                  
            },
            error: (error: any) => {
                this.showPreviewDialog = false;
                this.savingForm = false;
            },
        });
    }
    private isEditOrCloneMode(): boolean {
        return this.isEditMode || this.cloneMode;
    }
    private prepareImageForSave(imageType: 'logo' | 'cover'): string | null {
        if (imageType === 'logo') {
            if (this.isEditOrCloneMode() && !this.logoModified) {
                return this.formSettings.logoImage;
            } else {
                return this.formSettings.logoImage;
            }
        } else {
            if (this.isEditOrCloneMode() && !this.coverModified) {
                return this.formSettings.coverImage;
            } else {
                return this.formSettings.coverImage || null;
            }
        }
    }
    cancelPreview() {
        this.showPreviewDialog = false;
        this.previewFormData = null;
    }

    validateFormSettings(): boolean {
        if (!this.formSettings.formName?.trim()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid Form Name',
                detail: 'Please enter a valid form name'
            });
            return false;
        }

        if (!this.formSettings.logoImage) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Logo Required',
                detail: 'Please upload a logo image'
            });
            return false;
        }

        return true;
    }

    trackById(index: number, item: any): number {
        return item.section_id || index;
    }

    trackByFieldId(index: number, field: any): string | number {
        return field.id || index;
    }

    previewForm() {
        let logoUrl: string;
        let coverUrl: string;
        const validation = this.validateForm();
        if (this.isEditMode) {
            logoUrl = this.logoModified
                ? this.logoBaseUrl + this.formSettings.logoImage
                : this.formSettings.logoPreview;
            coverUrl = this.coverModified
                ? this.coverBaseUrl + this.formSettings.coverImage
                : this.formSettings.coverPreview;
        } else {
            logoUrl = this.formSettings.logoPreview;
            coverUrl = this.formSettings.coverPreview;
        }
        if (!validation.isValid) {
            validation.errors.forEach(error => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: error
                });
            });
            return;
        }

        const formPayload = {
            name: this.formSettings.formName.trim(),
            label: this.formSettings.formName.toLowerCase().replace(/\s+/g, '_'),
            logo: logoUrl,
            cover_image: coverUrl,
            header_content: this.headerContent?.trim() || null,
            footer_content: this.footerContent?.trim() || null,
            form_type: this.selectedCategory,
            form_fields: this.formLayoutSections.map(section => ({
                section_id: section.section_id,
                section_label: section.section_label.trim(),
                section_form_fields: this.groupSectionFields(section.section_form_fields, true)
            })),
            bg_colour: this.formSettings.bg_colour
        };

        this.formStateService.updateFormState(formPayload);
        const previewUrl = `${window.location.origin}/forms/view`;
        window.open(previewUrl, 'formPreview');
    }

    private debounce(func: Function, wait: number) {
        let timeout: any;
        return (...args: any[]) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    private updateFormStateWithDebounce = this.debounce(() => {
        const validation = this.validateForm();
        if (validation.isValid) {
            const currentState = {
                name: this.formSettings.formName,
                label: this.formSettings.formName.toLowerCase().replace(/\s+/g, '_'),
                logo: this.formSettings.logoPreview,
                cover_image: this.formSettings.coverPreview,
                header_content: this.headerContent?.trim() || null,
                footer_content: this.footerContent?.trim() || null,
                form_type: this.selectedCategory,
                form_fields: this.formLayoutSections.map(section => ({
                    section_id: section.section_id,
                    section_label: section.section_label,
                    section_form_fields: this.groupSectionFields(section.section_form_fields, true)
                })),
                bg_colour: this.formSettings.bg_colour
            };
            this.formStateService.updateFormState(currentState);
            if(this.selectedField) {
                this.showFieldPropertiesDependenciesStructure();
            }
        }
    }, 300);

    onFormNameChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        if (target && this.formSettings) {
            this.formSettings.formName = target.value;
            this.updateFormStateWithDebounce();
        }
    }

    onHeaderContentChange(event: Event): void {
        const target = event.target as HTMLTextAreaElement;
        if (target) {
            this.headerContent = target.value;
            this.updateFormStateWithDebounce();
        }
    }

    onFooterContentChange(event: Event): void {
        const target = event.target as HTMLTextAreaElement;
        if (target) {
            this.footerContent = target.value;
            this.updateFormStateWithDebounce();
        }
    }

    validateBasicDetails() {
        if (!this.formSettings.formName && !this.formSettings.logoPreview && !this.formSettings.logoImage) {
            this.router.navigate(
                ["/settings"],
                { queryParams: { menu: "form-builder", category: this.selectedCategory }, replaceUrl: true }
            );
            return;
        }

        this.formSettings.touched = true;
        const missingFields: string[] = [];
        if (!this.formSettings.formName) {
            missingFields.push('form name');
        }
        if (!this.formSettings.logoImage || !this.formSettings.logoPreview) {
            missingFields.push('form logo');
        }
        if (missingFields.length) {
            const formattedList = missingFields.join(' and ');
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing Required Details',
                detail: `The ${formattedList} ${missingFields.length === 1 ? 'is' : 'are'} missing. Please fill them in before proceeding.`,
            });
            return;
        }

        this.showFormDetailsEdit = false;
    }

    saveProperties() {
        if(!this.selectedField?.label) {
            this.messageService.add({
                severity: "warn",
                summary: "Missing required details",
                detail: "Form is missing some required details.",
            });
            return;
        }

        if((this.selectedField?.label?.length || 0) > 100) {
             this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Label cannot exceed 100 characters'
            });
            return;
        }

        if((this.selectedField?.placeholder?.length || 0) > 100) {
             this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Placeholder cannot exceed 100 characters'
            });
            return;
        }

        const descriptionMaxLength = this.descriptionMaxLength(this.selectedField?.type);
        if((this.selectedField?.description?.length || 0) > descriptionMaxLength) {
             this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `Description cannot exceed ${descriptionMaxLength} characters`
            });
            return;
        }

        if (this.selectedField?.options?.length) {
            let hasDuplicateOptionValue = false;
            let hasNoOptionValue = false;
            const seenValues = new Set();

            this.selectedField.options.forEach((option) => {
                if (seenValues.has(option.label.toLowerCase().trim())) {
                    hasDuplicateOptionValue = true;
                } else {
                    seenValues.add(option.label.toLowerCase().trim());
                }

                if(!option.label.toLowerCase().trim()) {
                    hasNoOptionValue = true;
                }
            });

            if (hasDuplicateOptionValue) {
                this.messageService.add({
                    severity: "warn",
                    summary: "Duplicate option values",
                    detail: "There are duplicate options in the field.",
                });
                return;
            }
            
            if (hasNoOptionValue) {
                this.messageService.add({
                    severity: "warn",
                    summary: "Missing option value",
                    detail: "One or more options have an empty invalid label.",
                });
                return;
            }
        }

        this.showFieldProperties = false;
        this.updateFormStateWithDebounce();
    }

    detector = new ChangeDetector();
    trackChanges() {
        this.detector.clear();
        this.detector.registerVariablesWithGetters({
            formSettings: () => this.formSettings,
            headerContent: () => this.headerContent,
            footerContent: () => this.footerContent,
            formLayoutSections: () => this.formLayoutSections,
            selectedCategory: () => this.selectedCategory
        })

        if(Object.keys(this.formBuilderService.formSettings.value || {}).length || this.cloneMode) {
            this.formSettings.touched = true;
        }
    }

    // System fields
    isSystemField(field: FormField) {
        const systemEditableFields: Set<string> = new Set(["first_name", "last_name", "email_id", "confirm_email_id", "mobile_number", "confirm_mobile_number", "date_of_birth", "gender", "father_name", "mother_name", "address_line_1", "address_line_2", "city", "state", "pin_code", "country", "final_recommendation", "offer_acceptance", "rejection_reason", "pg_degree_type", "ug_degree_type", "diploma_degree_type", "diploma_university_name", "pg_university_name", "ug_university_name", "diploma_specialization", "pg_specialization", "ug_specialization"]);
        if(systemEditableFields.has(field.name)) {
            return true;
        }

        return false;
    }

    // Custom Fields
    customFieldFormDetector = new ChangeDetector();
    trackCustomFieldFormChanges() {
        this.customFieldFormDetector.clear();
        this.customFieldFormDetector.registerFormGroups({
            form: this.customFieldForm
        })
    }

    fetchCustomFields() {
        if(this.fetchedCustomFields) {
            return;
        }

        this.loadingCustomFields = true;
        this.formBuilderService.getCustomFormFieldsFastApi(this.selectedCategory).subscribe({
            next: (res) => {
                this.loadingCustomFields = false;
                this.fetchedCustomFields = true;
                const response = res.body as any;
                this.formCustomFieldsCount = response.field_count || 0;
                this.formCustomFieldsMaxCount = response.max_fields || 50;
                if(response?.form_fields && response.form_fields?.length) {
                    this.formCustomFields = this.processSections(response.form_fields || []);
                    this.markUsedFieldsAsDisabled();
                }
            },
            error: (err) => {
                this.loadingCustomFields = false;
            }
        });
    }

    createCustomField() {
        this.editingCustomField = null;
        this.customFieldForm = this.fb.group({
            label: ['', [Validators.required, Validators.maxLength(100)]],
            placeholder: ['', [Validators.maxLength(100)]],
            description: ['', [this.descriptionLengthValidator()]],
            type: ['', [Validators.required]],
            options: this.fb.array<FormGroup>([]),
            properties: this.fb.group({
                file_format: this.fb.control<string[]>([]),
                file_max_size: this.fb.control<string>('')
            })
        });
        this.resetCustomFieldFormValue()
        this.showCustomFieldCreateDialog = true;
    }

    editCustomField(field: FormField) {
        this.editingCustomField = field;
        this.resetCustomFieldFormValue(field)
        this.showCustomFieldCreateDialog = true;
    }

    closeShowCustomField() {
        this.showCustomFieldCreateDialog = false;
    }

    resetCustomFieldFormValue(field: FormField | null = null) {
        this.customFieldForm = this.fb.group({
            label: [field?.label || "", [Validators.required, Validators.maxLength(100)]],
            placeholder: [field?.placeholder || "", [Validators.maxLength(100)]],
            description: [field?.description || "", [this.descriptionLengthValidator()]],
            type: [field?.type || "", [Validators.required]],
            options: this.fb.array<FormGroup>([]),
            properties: this.fb.group({
                file_format: this.fb.control<string[]>(field?.properties?.file_format ? field.properties.file_format : []),
                file_max_size: this.fb.control<string>(field?.properties?.file_max_size ? field.properties.file_max_size.replace(/[^\d]/g, '') : "")
            })
        });

        if(field?.options) {
            field.options.forEach((option) => {
                this.addCustomFieldOption(option);
            })
        }

        this.trackCustomFieldFormChanges();
    }

    isDisplayFieldType(type: string | undefined | null): boolean {
        return this.DISPLAY_FIELD_TYPES.includes((type || '').toLowerCase());
    }

    get availableParagraphTokens(): { label: string, token: string }[] {
        if (this.selectedCategory === "feedback") { return []; }

        const signature = this.formLayoutSections
            .map((section) => section.section_form_fields
                .map((field) => `${field.name}:${field.label}:${field.type}:${field.is_required}`)
                .join(','))
            .join('|');
        if (this.paragraphTokenCache?.signature === signature) {
            return this.paragraphTokenCache.tokens;
        }

        const tokens: { label: string, token: string }[] = [];
        const seen = new Set<string>();

        const collect = (field: FormField) => {
            if (field.element_type === 'group' && field.form_fields) {
                field.form_fields.forEach(collect);
                return;
            }
            if (!field.name || seen.has(field.name)) { return; }
            if (!this.PLACEHOLDER_FIELD_TYPES.includes((field.type || '').toLowerCase())) {
                return;
            }
            seen.add(field.name);
            tokens.push({ label: field.label || field.name, token: `{{${field.name}}}` });

            if (field.name === 'date_of_birth' && !seen.has('age')) {
                seen.add('age');
                tokens.push({ label: 'Age', token: '{{age}}' });
            }
        };

        this.formLayoutSections.forEach((section) => section.section_form_fields.forEach(collect));
        this.paragraphTokenCache = { signature, tokens };
        return tokens;
    }

    trackParagraphCursor(elementId: string) {
        const element = document.getElementById(elementId) as HTMLTextAreaElement | null;
        if (!element) { return; }
        this.paragraphCursor = {
            id: elementId,
            start: element.selectionStart ?? element.value.length,
            end: element.selectionEnd ?? element.value.length
        };
    }

    private spliceToken(elementId: string, currentValue: string, token: string): string {
        const cursor = this.paragraphCursor?.id === elementId
            ? this.paragraphCursor
            : { start: currentValue.length, end: currentValue.length };

        const next = currentValue.substring(0, cursor.start) + token + currentValue.substring(cursor.end);
        const caret = cursor.start + token.length;
        this.paragraphCursor = { id: elementId, start: caret, end: caret };

        setTimeout(() => {
            const element = document.getElementById(elementId) as HTMLTextAreaElement | null;
            element?.focus({ preventScroll: true });
            element?.setSelectionRange(caret, caret);
        });

        return next;
    }

    togglePlaceholderPicker(target: 'custom-field' | 'selected-field') {
        if (this.showPlaceholderPicker && this.placeholderTarget === target) {
            this.showPlaceholderPicker = false;
            return;
        }
        this.placeholderTarget = target;
        this.showPlaceholderPicker = true;
    }

    insertSelectedPlaceholder(token: string) {
        if (this.placeholderTarget === 'custom-field') {
            this.insertPlaceholderIntoCustomField(token);
        } else if (this.placeholderTarget === 'selected-field') {
            this.insertPlaceholderIntoSelectedField(token);
        }
    }

    private insertPlaceholderIntoCustomField(token: string) {
        const control = this.customFieldForm.get('description');
        if (!control) { return; }
        control.setValue(this.spliceToken('custom_field_description', control.value || '', token));
        control.markAsDirty();
    }

    private insertPlaceholderIntoSelectedField(token: string) {
        if (!this.selectedField) { return; }
        const next = this.spliceToken('field_description', this.selectedField.description || '', token);
        this.selectedField.description = next;
        this.updateFieldProperty(this.selectedField, 'description', next);
    }

    private unresolvedPlaceholdersIn(text: string | undefined | null): string[] {
        if (!text) { return []; }

        const known = new Set(this.availableParagraphTokens.map((entry) => entry.token));
        const used = Array.from(
            text.matchAll(/\{\{\s*([^{}]*?)\s*\}\}/g), (match) => `{{${match[1]}}}`
        );

        return Array.from(new Set(used.filter((token) => !known.has(token))));
    }

    private optionalReferencedFieldsIn(text: string | undefined | null): string[] {
        if (!text) { return []; }

        const used = new Set(
            Array.from(text.matchAll(/\{\{\s*([^{}]*?)\s*\}\}/g), (match) => match[1])
        );
        if (used.has('age')) { used.add('date_of_birth'); }

        const optional: string[] = [];

        const check = (field: FormField) => {
            if (field.element_type === 'group' && field.form_fields) {
                field.form_fields.forEach(check);
                return;
            }
            if (used.has(field.name) && !field.is_required) {
                optional.push(field.label || field.name);
            }
        };

        this.formLayoutSections.forEach((section) => section.section_form_fields.forEach(check));
        return Array.from(new Set(optional));
    }

    private paragraphsWithUnresolvedPlaceholders(): { field: string, tokens: string[] }[] {
        const issues: { field: string, tokens: string[] }[] = [];

        const scan = (field: FormField) => {
            if (field.element_type === 'group' && field.form_fields) {
                field.form_fields.forEach(scan);
                return;
            }
            if (!this.isDisplayFieldType(field.type)) { return; }

            const tokens = this.unresolvedPlaceholdersIn(field.description);
            if (tokens.length) {
                issues.push({ field: field.label || field.name, tokens });
            }
        };

        this.formLayoutSections.forEach((section) => section.section_form_fields.forEach(scan));
        return issues;
    }

    private paragraphsWithOptionalReferences(): { field: string, optional: string[] }[] {
        const issues: { field: string, optional: string[] }[] = [];

        const scan = (field: FormField) => {
            if (field.element_type === 'group' && field.form_fields) {
                field.form_fields.forEach(scan);
                return;
            }
            if (!this.isDisplayFieldType(field.type)) { return; }

            const optional = this.optionalReferencedFieldsIn(field.description);
            if (optional.length) {
                issues.push({ field: field.label || field.name, optional });
            }
        };

        this.formLayoutSections.forEach((section) => section.section_form_fields.forEach(scan));
        return issues;
    }

    private descriptionMaxLength(type: string | undefined | null): number {
        return this.isDisplayFieldType(type)
            ? this.DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH
            : this.INPUT_FIELD_DESCRIPTION_MAX_LENGTH;
    }

    private descriptionLengthValidator() {
        return (control: AbstractControl): ValidationErrors | null => {
            const value: string = control.value || '';
            if (!value) {
                return null;
            }
            const max = this.descriptionMaxLength(control.parent?.get('type')?.value);
            return value.length > max
                ? { maxlength: { requiredLength: max, actualLength: value.length } }
                : null;
        };
    }

    get canShowCustomFieldDescriptionOnly(): boolean {
        return this.isDisplayFieldType(this.customFieldForm.get('type')?.value);
    }

    get canShowCustomFieldOptions(): boolean {
        return ['radio', 'dropdown', 'multi-dropdown', 'checkbox'].includes(this.customFieldForm.get('type')?.value?.toLowerCase() || '')
    }

    get canShowCustomFieldProperties(): boolean {
        return ['file', 'multi-file'].includes(this.customFieldForm.get('type')?.value?.toLowerCase() || '')
    }

    get options(): FormArray {
        return this.customFieldForm.get('options') as FormArray;
    }

    changeCustomFieldType() {
        const emptyOptions = this.fb.array(this.canShowCustomFieldOptions ? [
            this.fb.group({
                label: ['', Validators.required],
                value: ['']
            })
        ] : []);
        this.customFieldForm.setControl('options', emptyOptions);

        // The description limit depends on the selected type, so re-check it on change.
        // Display-only types have no placeholder, so drop any value carried over.
        const descriptionCtrl = this.customFieldForm.get('description');
        const placeholderCtrl = this.customFieldForm.get('placeholder');

        if (this.canShowCustomFieldDescriptionOnly && placeholderCtrl?.value) {
            placeholderCtrl.setValue('');
        }
        descriptionCtrl?.updateValueAndValidity();

        const fileFormatCtrl = this.customFieldForm.get('properties.file_format');
        const fileSizeCtrl = this.customFieldForm.get('properties.file_max_size');
        
        if(fileSizeCtrl) {
            if (this.canShowCustomFieldProperties) {
                fileSizeCtrl.setValidators([Validators.required]);
            } else {
                fileSizeCtrl.clearValidators();
            }

            fileSizeCtrl.updateValueAndValidity();
        }

        if(fileFormatCtrl) {
            if (this.canShowCustomFieldProperties) {
                fileFormatCtrl.setValidators([Validators.required, Validators.minLength(1)]);
            } else {
                fileFormatCtrl.clearValidators();
            }

            fileFormatCtrl.updateValueAndValidity();
        }
    }

    addCustomFieldOption(option: { label: string, value: string } | null = null) {
        if (this.options.length > 0) {
            const lastOptionGroup = this.options.at(this.options.length - 1);
            if (lastOptionGroup.invalid) {
                lastOptionGroup.markAllAsTouched();
                return;
            }
        }

        const optionGroup = this.fb.group({
            label: [option?.label ? option.label : "", Validators.required],
            value: [option?.value ? option.value : ""]
        });
        this.options.push(optionGroup);
    }

    removeCustomFieldOption(index: number) {
        this.options.removeAt(index);
    }

    saveCustomField(event: MouseEvent) {
        this.customFieldForm.markAllAsTouched();
        this.customFieldForm.updateValueAndValidity();

        if(this.customFieldForm.invalid) {
            this.messageService.add({
                severity: "warn",
                summary: "Missing required details",
                detail: "Form is missing some required details.",
            });
            return;
        }

        const payload = {
            ...this.customFieldForm.value,
            form_type: this.selectedCategory,
            options: this.canShowCustomFieldOptions ? this.customFieldForm.value?.options?.map((val: any) => {
                return {
                    label: val.label,
                    value: this.generateValueFromLabel(val.label)
                }
            }) : null,
            properties: this.canShowCustomFieldProperties ? {
                ...this.customFieldForm.value?.properties,
                file_max_size: this.customFieldForm.value?.properties?.file_max_size ? `${this.customFieldForm.value?.properties?.file_max_size}MB` : '1MB'
            } : null
        }

        this.saveCustomFieldApi(payload);
    }

    saveCustomFieldApi(payload: any) {
        this.savingCustomField = true;
        const successResponse = (responseBody: any) => {
            this.savingCustomField = false;
            this.fetchedCustomFields = false;
            this.fetchCustomFields();
            this.closeShowCustomField();
            this.formCustomFields = [];
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: responseBody.detail || "Custom field saved successfully."
            });
        }

        if(this.editingCustomField) {
            this.formBuilderService.updateCustomFormFieldsFastApi(this.editingCustomField.id, payload).subscribe({
                next: (res) => {
                    successResponse(res.body);
                    this.formLayoutSections.forEach((layoutSection) => {
                        layoutSection.section_form_fields.forEach((usedField) => {
                            if(usedField.name === this.editingCustomField?.name && usedField.section_label?.toLowerCase() === "custom fields") {
                                usedField.label = payload.label;
                                usedField.placeholder = payload.placeholder;
                                usedField.description = payload.description;
                                usedField.type = payload.type;
                                usedField.options = payload.options;
                                usedField.properties = payload.properties;
                            }
                        })
                    });
                },
                error: (err) => {
                    this.savingCustomField = false;
                }
            })
        } else {
            this.formBuilderService.createCustomFormFieldsFastApi(payload).subscribe({
                next: (res) => {
                    successResponse(res.body);
                },
                error: (err) => {
                    this.savingCustomField = false;
                }
            })
        }
    }

    isDependentField(currentField: FormField) {
        const overallfields: { label: string, option: string }[] = [];
        for(const section of JSON.parse(JSON.stringify([...this.formLayoutSections]))) {
            for(const field of section.section_form_fields) {
                const dependencies = JSON.parse(JSON.stringify(field["dependencies"] || "null"));
                if(dependencies) {
                    if(Array.isArray(dependencies)) {
                        for(const dep of dependencies) {
                            if(dep?.show_fields?.includes(currentField.name)) {
                                const optionLabel = field.options?.find((op: any) => op.value === dep.option)
                                overallfields.push({label: field.label, option: optionLabel?.label || dep.option})
                            }
                        }
                    }

                    if(!Array.isArray(dependencies)) {
                        for(const optionEntry of Object.entries(dependencies)) {
                            const fields: any[] = (optionEntry[1] as any[]) || [];

                            if(fields.includes(currentField.name)) {
                                const optionLabel = field.options?.find((op: any) => op.value === optionEntry[0])
                                overallfields.push({label: field.label, option: optionLabel?.label || optionEntry[0]})
                            }
                        }
                    }
                }
            }
        }
        
        return overallfields;
    }

    dependentFieldOptions(currentField: FormField): { label: string, value: string }[] {
        const fields: FormField[] = [];
        this.formLayoutSections.forEach((section) => {
            section.section_form_fields?.forEach((field) => {
                if (field.name !== currentField.name && field.name !== "email_id" && field.name !== "confirm_email_id") {
                    fields.push(field);
                }
            })
        })

        return fields.map((field) => { return { label: field.label, value: field.name, isCustom: field.section_label?.toLowerCase() === "custom fields" } });
    }

    dependentFieldOptionSelectedFieldsUpdate(option: FieldOption, event: MultiSelectChangeEvent) {
        if (!this.selectedField) return;
        if (!this.selectedField["dependencies"]) {
            this.selectedField["dependencies"] = {};
        }

        const selectedDependecyFields = (this.selectedField["dependencies"] || {})[`${option.value}`]
        if (selectedDependecyFields) {
            (this.selectedField["dependencies"] || {})[`${option.value}`] = event.value;
        } else {
            this.selectedField["dependencies"][option.value] = event.value;
        }
    }

    handleRemovedDependencyFields() {
        const doesFieldExists = (currentField: string) => {
            let exists = false;
            
            this.formLayoutSections.forEach((section) => {
                section.section_form_fields.forEach((field) => {
                    if(currentField === field.name) {
                        exists = true;
                    }
                })
            })

            return exists;
        }

        this.formLayoutSections.forEach((section) => {
            section.section_form_fields.forEach((field) => {
                if(field["dependencies"]) {
                    if(Array.isArray(field["dependencies"]))  {
                        field["dependencies"].forEach((dep) => {
                            if(dep.show_fields) {
                                dep.show_fields = dep.show_fields.filter((depField: string) => doesFieldExists(depField))
                            }
                        })
                    } else {
                        Object.keys(field["dependencies"]).forEach((key) => {
                            field["dependencies"][key] = field["dependencies"][key].filter((depField: string) => doesFieldExists(depField))
                        })
                    }
                }
            })
        })
    }

    headerBgGradientChange(event: Gradient) {
        this.formSettings.bg_colour = event as any;
    }
}
